import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button1 from '../../components/UI/Button/Button1';
import { getDevices, getPagedDevicesAPI, PowerSearch } from '../../Api Methods/Api';

import classes from "./GetAllDevices.module.css";
import DataManager from '../../hooks/DataManager';

const GetAllPagedDevices = ({ searchQuery, setIsLoading, handleFilterLogic, categoryFilter, sortBy, setSearchQuery, setIsGetAllDevicesPressed, isGetAllDevicesPressed, filteredResults, setTotalPages, setFilteredResults, setMaxPagedFetches, maxPagedFetches, setPageFetchedIndex, pageFetchedIndex, pageSize, pageNumber, totalDevices, setTotalDevices, getAllDevices }) => {
    const dataManager = new DataManager();

    pageSize = dataManager.getItem('pageSize');
    pageNumber = pageFetchedIndex;

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const companyName = useSelector(state => state.auth.companyName);
    const showButton = false;

    const ApiData = {
        token,
        client
    }

    const GetAllDevicesTimer = useRef();

    const GetAllDevices = async (GetAllDevicesTimer) => {        
        GetAllDevicesTimer.current = Date.now();
        const triggerTime = GetAllDevicesTimer.current;
        const online = dataManager.getItem('online');
        const offline = dataManager.getItem('offline');
        const noTag = dataManager.getItem('noTag');
        const sort = dataManager.getItem('sort');
        const responseData = await getPagedDevicesAPI(ApiData, pageSize, pageNumber, online, offline, noTag, sort, dispatch);
        console.log(ApiData)
        console.log(pageSize)
        console.log(pageNumber)
        console.log(online)
        console.log(offline)
        console.log(noTag)
        console.log(sort)
        
        const totalDevices = responseData[0].totalDevices["COUNT(*)"];
        const Sites = responseData;
        console.log(Sites)
        setTotalPages(Math.ceil(totalDevices/pageSize));

        if (dataManager.getItem('isAddAccessMode')){
            setTotalDevices(totalDevices - dataManager.getItem('existingSites').length)
        } else {
            setTotalDevices(totalDevices);
        }

        if (GetAllDevicesTimer.current == triggerTime){
            //setLocalCategoryFilters(categoryFilter);
            //setLocalSortBy(sortBy);
            setIsLoading(false);
            setGetAllDevicesButtonText("All Sites");
            handleFilterLogic(Sites, companyName, categoryFilter, sortBy);
        }
    }

    useEffect(() => {
        console.log('called')

        //if (!dataManager.getItem('filteredResults')?.length > 0){
            setCategoryFilters()
            if (dataManager.getItem('sort') !== 6){
                setSort()
            }
            
        //}
    

        if (isGetAllDevicesPressed && dataManager.getItem('searchQuery') === ""){
            GetAllDevices(GetAllDevicesTimer)
        }
    }, [pageNumber, pageSize, isGetAllDevicesPressed, getAllDevices, categoryFilter, sortBy])

    function setCategoryFilters(){
        dataManager.setItem('online', 0);
        dataManager.setItem('offline', 0);
        dataManager.setItem('noTag', 0);

        categoryFilter.forEach((filter) => {
            switch (filter) {
                case "Online": {
                    dataManager.setItem('online', 1);
                    break;
                }
                case "Offline": {
                    dataManager.setItem('offline', 1);
                    break;
                }
                case "No site name": {
                    dataManager.setItem('noTag', 1);
                    break;
                }
                case "Empty sites" :{
                    //online = 1 AND offline = 0 AND notag = 1 AND sort = 6
                    dataManager.setItem('online', 1)
                    dataManager.setItem('offline', 0)
                    dataManager.setItem('noTag', 1)
                    dataManager.setItem('sort', 6);
                    break;
                }
                case "all": {
                    dataManager.setItem('online', 0);
                    dataManager.setItem('offline', 0);
                    dataManager.setItem('noTag', 0);
                    break;
                }
                default: {
                    dataManager.setItem('online', 0);
                    dataManager.setItem('offline', 0);
                    dataManager.setItem('noTag', 0);
                    break;
                }
            }
        });
    }

    function setSort(){
        console.log('called')
        dataManager.setItem('sort', -1)
        switch (sortBy[0]){
            case 'Site name - Asc': {
                dataManager.setItem('sort', 0);
                break;
            } 
            case "Site name - Desc": {
                dataManager.setItem('sort', 1);
                break;
            }
            case "Firmware - Asc": {
                dataManager.setItem('sort', 2);
                break;
            }
            case "Firmware - Desc": {
                dataManager.setItem('sort', 3);
                break;
            }
            case "User Count - Asc": {
                dataManager.setItem('sort', 4);
                break;
            }
            case "User Count - Desc": {
                dataManager.setItem('sort', 5);
                break;
            }
            default : {
                dataManager.setItem('sort', -1);
                break;
            }
        }
    }
    
    const [getAllDevicesButtonText, setGetAllDevicesButtonText] = useState("All Sites");

    function arraysAreIdentical(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((value, index) => value === arr2[index]);
    }

    const HandleSetGetAllDevices = () => {
        setIsGetAllDevicesPressed(true)
        dataManager.setItem('allSitesPressed', true);
        setPageFetchedIndex(1);
        setFilteredResults([]);
        setSearchQuery("");
        GetAllDevices(GetAllDevicesTimer)
    }

    return (
        <>
        {showButton && (
            <Button1
                style={{ height: "50px", fontSize: "16px", minWidth: "120px" }}
                type="button"
                className={classes.button}
                onClick={HandleSetGetAllDevices}
            >
                {getAllDevicesButtonText}
            </Button1>
        )}
    </>
    )
};

export default GetAllPagedDevices;
